import { render, staticRenderFns } from "./ReviewerEditDialog.vue?vue&type=template&id=aec0cc00&scoped=true&"
import script from "./ReviewerEditDialog.vue?vue&type=script&lang=js&"
export * from "./ReviewerEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReviewerEditDialog.vue?vue&type=style&index=0&id=aec0cc00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec0cc00",
  null
  
)

export default component.exports